import React from 'react';
import styled from 'styled-components';
import TrueImpactCapsule from 'shared/design-system/components/TrueImpactCapsule';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

export const beneficiariesTableGridStyles = `
  display: grid;
  gap: ${SPACERS.small};
  align-items: center;
  grid-template-columns: 1fr 1.3fr 1.3fr 1fr;
  padding: ${SPACERS.small} ${SPACERS.extraLarge};
`;

const StyledDiv = styled.div`
  ${beneficiariesTableGridStyles}
  background-color: ${COLORS.grayLight};
  margin-bottom: 12px;
`;

const style: React.CSSProperties = { justifySelf: 'center' };
const ReportBeneficiariesHeader: React.FC = () => {
  return (
    <StyledDiv>
      <div>
        <TrueImpactCapsule
          variant="body-small-bold"
          backgroundColor="grayLightest"
        >
          CATEGORY
        </TrueImpactCapsule>
      </div>
      <div>
        <TrueImpactCapsule
          variant="body-small-bold"
          backgroundColor="grayLightest"
        >
          GROUP
        </TrueImpactCapsule>
      </div>
      <div>
        <TrueImpactCapsule
          variant="body-small-bold"
          backgroundColor="grayLightest"
        >
          SUB-GROUP*
        </TrueImpactCapsule>
      </div>
      <div>
        <TrueImpactCapsule
          variant="body-small-bold"
          backgroundColor="grayLightest"
        >
          % SERVED
        </TrueImpactCapsule>
      </div>
    </StyledDiv>
  );
};

export default ReportBeneficiariesHeader;
